import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Регистрация Service Worker для PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ PWA: Приложение готово к офлайн использованию');
  },
  onUpdate: (registration) => {
    console.log('🔄 PWA: Доступно обновление');
    // Можно показать уведомление пользователю
    if (window.confirm('Доступна новая версия приложения. Обновить?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  },
});

// Измерение производительности
reportWebVitals();
